import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_ENTERPRISE_PRODUCT = 'GET_ENTERPRISE_PRODUCT';
export const GET_ENTERPRISE_PRODUCT_SUCCESS = 'GET_ENTERPRISE_PRODUCT_SUCCESS';
export const GET_ENTERPRISE_PRODUCT_FAILURE = 'GET_ENTERPRISE_PRODUCT_FAILURE';

// Action Creators
export const getEnterpriseProduct = () => ({
  type: GET_ENTERPRISE_PRODUCT,
});

export const getEnterpriseProductSuccess = (data) => ({
  type: GET_ENTERPRISE_PRODUCT_SUCCESS,
  payload: data,
});

export const getEnterpriseProductFailure = (error) => ({
  type: GET_ENTERPRISE_PRODUCT_FAILURE,
  payload: error,
});

// Thunk Function
export const getEnterpriseProductCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(getEnterpriseProduct());
    try {
      const response = await getMethodWithToken(url.product + data);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getEnterpriseProductSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getEnterpriseProductFailure(response?.data));
      }
    } catch (error) {
      dispatch(getEnterpriseProductFailure(error?.message));
    }
  };
};
